export enum InvalidCaptchaFeedback {
  EmailAlreadyExists = 'email_exists',
  InvalidRegistration = 'invalid_registration',
  InvalidCaptcha = 'invalid_captcha',
  InvalidToken = 'invalid_token',
  LoginFailed = 'login_failed',
  V2Success = 'v2_success',
  SetPasswordFailed = 'set_password_failed',
  RegistrationSuccess = 'registration_success',
  LoginSuccess = 'login_success',
}
